import { useState } from 'react'
import { useDashboard } from './Provider'
import { usePermission } from '@shared/hooks/permissions'
import {
    useTheme,
    useMediaQuery
} from '@mui/material'
import {
    useLocation,
    Link
} from 'react-router-dom'
import MuiDrawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Collapse from '@mui/material/Collapse'
import BusinessIcon from '@mui/icons-material/Business'
import LightbulbIcon from '@mui/icons-material/Lightbulb'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import GroupIcon from '@mui/icons-material/Group'
import EngineeringIcon from '@mui/icons-material/Engineering'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const normalizePath = (path = '') => path.replace(/\/+$/, '') || '/'

const NavItem = ({
    text,
    icon,
    to,
    isChild=false,
    children
}) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const { setOpen: setDrawerOpen } = useDashboard()
    const [open, setOpen] = useState(false)
    const { pathname } = useLocation()
    const isSelected = to ? normalizePath(pathname) === normalizePath(to) : false
    const hasChildren = !!children

    return (
        <>
            <ListItemButton
                selected={isSelected}
                component={hasChildren ? 'div' : Link}
                to={hasChildren ? undefined : to}
                onClick={() => {
                    if (isMobile) {
                        setDrawerOpen(false)
                    }
                    if (hasChildren) {
                        setOpen(!open)
                    }
                }}
                sx={{
                    pl: isChild ? 9 : 'auto',
                    '&.Mui-selected': {
                        backgroundColor: 'transparent',
                        color: 'primary.main',
                        '&:hover': { backgroundColor: 'action.hover' },
                        '& .MuiListItemText-primary': { color: 'primary.main' },
                        '& .MuiListItemIcon-root': { color: 'primary.main' },
                    },
                }}
            >
                {icon && <ListItemIcon>{icon}</ListItemIcon>}
                <ListItemText primary={text}/>
                {hasChildren && <ExpandMoreIcon sx={{transform: `rotate(${open ? '180deg' : '0'})`}}/>}
            </ListItemButton>
            <Collapse in={open} unmountOnExit>{children}</Collapse>
        </>
    )
}


export default function Drawer() {
    const {
        open,
        setOpen
    } = useDashboard()
    const { hasPermission } = usePermission()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <MuiDrawer
            variant={isMobile ? 'temporary' : 'persistent'}
            open={open}
            onClose={() => setOpen(false)}
            slotProps={{ paper: { sx: { border: 'none' } } }}
        >
            <List sx={{ width: '250px' }}>
                <NavItem
                    to='/dashboard/'
                    text='نظرة سريعة'
                    icon={<LightbulbIcon />}
                />
                <NavItem
                    to='/dashboard/estimations'
                    text='المقايسات'
                    icon={<AttachFileIcon />}
                />
                <NavItem
                    to='/dashboard/offices'
                    text='المكاتب'
                    icon={<BusinessIcon />}
                />
                {(hasPermission('add_pdcdelegate') && hasPermission('change_pdcdelegate') && hasPermission('delete_pdcdelegate')) &&
                    <NavItem
                        to='/dashboard/pdc-delegates'
                        text='ممثلين الـ PDC'
                        icon={<EngineeringIcon />}
                    />
                }
                {(hasPermission('add_user') && hasPermission('change_user') && hasPermission('delete_user')) &&
                    <NavItem
                        to='/dashboard/users'
                        text='المستخدمين'
                        icon={<GroupIcon />}
                    />
                }
            </List>
        </MuiDrawer>
    )
}